import React, { useEffect, useState } from 'react'
import TermsAndConditionsModal from './TermsAndConditionsModal'
import { useShouldShowTermsModal } from '@src/utils/useShouldShowTermsModal'

const TermsAndConditionsModalWidget: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const { shouldShowModal, generalTermsAccepted, piiConsentAccepted } =
    useShouldShowTermsModal()

  useEffect(() => {
    if (shouldShowModal) {
      setModalOpen(true)
    }
  }, [shouldShowModal])

  return (
    <TermsAndConditionsModal
      open={modalOpen}
      setModalOpen={setModalOpen}
      generalTermsAccepted={generalTermsAccepted}
      piiDataConsentAcceptance={piiConsentAccepted}
    />
  )
}

export default TermsAndConditionsModalWidget
